import React from "react"
import { GetIco } from "../../../utils/icons"
import s from "./SelectPeriod.module.css"
import cn from 'classnames'
import { useOutside, useKeyUp } from "../../../hooks"
import { compareDates, formateDate } from "../../../helpers/date"
import SelectDays from '../SelectDays'
import { useEffect } from "react"


const SelectPeriod = ({ placeholder = 'Дата / период', classNameIcon='', classNameSelect='', className = '', children, rightList = false, initDate = {}, setUp, setFrom, onChange = (start, end) => {}, newDesign=false, resetPlaseholder=false }) => {
  const [ref, show, setShow] = useOutside(false)
  const [selectedDate1, setSelectedDate1] = React.useState(initDate.from ?? '')
  const [selectedDate2, setSelectedDate2] = React.useState(initDate.up ?? '')
  const [selectDateLabel, setSelectDateLabel] = React.useState(placeholder)
  const selectPeriod = [selectedDate1, selectedDate2].sort((d1, d2) => compareDates(new Date(d1), new Date(d2)))
  useEffect(() => {
    if (!initDate?.from?.length && !initDate?.up?.length && resetPlaseholder) {
      setSelectedDate1('')
      setSelectedDate2('')
      setSelectDateLabel(placeholder)
    }

  }, [initDate]);
  const onSave = async () => {
    if (selectedDate1 && selectedDate2) {
      setFrom(selectPeriod[0])
      setUp(selectPeriod[1])
      onChange?.(selectPeriod[0], selectPeriod[1])
      const from = formateDate(new Date(selectPeriod[0]), 'DD.MM.YYYY')
      const up = formateDate(new Date(selectPeriod[1]), 'DD.MM.YYYY')
      return setSelectDateLabel(from.slice(0, -4) + from.slice(-2) + ' - ' + up.slice(0, -4) + up.slice(-2))
    }
    if (selectedDate1) {
      setFrom(selectedDate1)
      return setSelectDateLabel(formateDate(new Date(selectedDate1), 'DD.MM.YYYY'))
    }
    else if (selectedDate2) {
      setFrom(selectedDate2)
      return setSelectDateLabel(formateDate(new Date(selectedDate2), 'DD.MM.YYYY'))
    }
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { if (initDate) onSave() }, [])

  const selectParams = { onClick: () => setShow(!show), tabIndex: 0, ...useKeyUp(() => setShow(!show)) }
  const btnSaveParams = { onClick: () => { setShow(false); onSave() }, disabled: (selectedDate1 || selectedDate2) ? false : true }

  return <div ref={ref} className={cn(s.wrapper, { [className]: className }, newDesign ? s.wrapperNewDevign : '')}>

    {children
      ? <span {...selectParams}>{children}</span>
      : <div className={cn(s.select, 'btn', {[classNameSelect]: classNameSelect}, newDesign ? 'backgroundNone' : '')} {...selectParams}>
        <span className={cn({ [s.placeholder]: selectDateLabel === placeholder })} >{selectDateLabel}</span>
        {newDesign ? 
          (<GetIco 
            style={{marginLeft:'auto'}} 
            className={cn(s.ico, { [classNameIcon]: classNameIcon }, { [s.active]: show }, s.icoNewDesign)} 
            icon="angle_arrow_small_down_new_design" />) 
          : 
          (<GetIco 
            className={cn(s.ico, { [classNameIcon]: classNameIcon }, { [s.active]: show })} 
            icon='angle_arrow_small_down' />)
        }
      </div>
    }

    <div className={cn(s.selectContainer, { [s.show]: show }, { [s.right]: rightList }, newDesign ? s.selectContainerNewDesign : '')}>
      <SelectDays newDesign={newDesign} selectedPeriod={true} valueDefault={initDate.from ?? ''} selectDate={setSelectedDate1} />
      <SelectDays newDesign={newDesign} selectedPeriod={true} valueDefault={initDate.up ?? ''} selectDate={setSelectedDate2} />
      <button className={cn('btn', s.btn, newDesign ? 'backgroundNone' : '')} {...btnSaveParams}>Выбрать</button>
    </div>
  </div >

}

export default SelectPeriod
